"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Used to output runtime warnings for developers,
 * Warnings throw locally but are suppressed in production
 */
var isProduction = process.env.NODE_ENV === "production";
var warning = function (condition, label) {
    var messages = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        messages[_i - 2] = arguments[_i];
    }
    if (isProduction || !condition)
        return;
    var message = "[" + label + "]\n" + messages.join("\n\n");
    // eslint-disable-next-line no-console
    console.warn(message);
};
exports.default = warning;
//# sourceMappingURL=warning.js.map